import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/logo-footer.png'
import _imports_1 from '@/assets/image/gongan.png'


const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "about" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://www.mgtv.com/",
    target: "_black",
    class: "about-item"
  }, "芒果TV"),
  /*#__PURE__*/_createVNode("a", {
    href: "http://www.eemedia.cn/",
    target: "_black",
    class: "about-item"
  }, "天娱传媒"),
  /*#__PURE__*/_createVNode("a", {
    href: "http://www.vfund.org/html/index.html",
    target: "_black",
    class: "about-item"
  }, "芒果V基金"),
  /*#__PURE__*/_createVNode("a", {
    href: "http://www.mgtv.com/zq/hnetv/",
    target: "_black",
    class: "about-item"
  }, "湖南经视"),
  /*#__PURE__*/_createVNode("a", {
    href: "http://www.happigo.com/",
    target: "_black",
    class: "about-item"
  }, "快乐购"),
  /*#__PURE__*/_createVNode("a", {
    href: "http://www.mgtv.com/gba/",
    target: "_black",
    class: "about-item"
  }, "湖南省广播电视协会"),
  /*#__PURE__*/_createVNode("a", {
    href: "http://www.mgtv.com/v/klcd/",
    target: "_black",
    class: "about-item"
  }, "快乐垂钓"),
  /*#__PURE__*/_createVNode("a", {
    href: "javascript:void(0);",
    class: "about-item empty"
  }, "芒果商标"),
  /*#__PURE__*/_createVNode("a", {
    href: "http://www.mgtv.com/pmb/",
    target: "_black",
    class: "about-item"
  }, "重点工程"),
  /*#__PURE__*/_createVNode("a", {
    href: "javascript:void(0);",
    class: "about-item empty"
  }, "芒果影视")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "security" }, [
  /*#__PURE__*/_createVNode("img", {
    alt: "",
    class: "logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("p", null, "Copyright 2020-2021 小芒电子商务有限责任公司 版权所有"),
    /*#__PURE__*/_createVNode("p", null, "互联网药品信息服务资格证书：（湘）-经营性-2021-0024号 ｜ 网络文化经营许可证：湘网文【2021】1245-017号"),
    /*#__PURE__*/_createVNode("p", null, "医疗器械网络交易服务第三方平台备案：（湘）网械平台备字【2021】第00024号 ｜ 增值电信业务经营许可证：湘B2-20200229"),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("a", {
        target: "_blank",
        href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43010502001221",
        style: {"color":"#b2b2b2"}
      }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_1 }),
        /*#__PURE__*/_createTextVNode(" 湘公网安备 43010502001221号 ")
      ]),
      /*#__PURE__*/_createTextVNode(" ｜ "),
      /*#__PURE__*/_createVNode("a", {
        target: "_blank",
        href: "https://xm.mgtv.com/dynamic-rules.html?article_id=92",
        style: {"color":"#b2b2b2"}
      }, "营业执照"),
      /*#__PURE__*/_createTextVNode(" ｜ "),
      /*#__PURE__*/_createVNode("a", {
        target: "_blank",
        href: "https://xm.mgtv.com/dynamic-rules.html?article_id=92",
        style: {"color":"#b2b2b2"}
      }, "证照信息")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}